import React from "react";
import { Layout } from "../components";
import { useIntl } from "react-intl";
import { useLanguage } from "../context";
import { getLocalizedPath } from "../helpers/routes";

const Faq = () => {
  const intl = useIntl();
  const { language } = useLanguage();

  // FAQ data - this could come from Strapi in the future
  const faqs = [
    {
      id: 1,
      question: intl.formatMessage({ id: "faq.question1", defaultMessage: "Quels services propose Africa Systems ?" }),
      answer: intl.formatMessage({ id: "faq.answer1", defaultMessage: "Africa Systems propose une gamme complète de solutions technologiques, notamment des systèmes de communication, des équipements de sécurité, des solutions IoT et des services de conseil informatique." })
    },
    {
      id: 2,
      question: intl.formatMessage({ id: "faq.question2", defaultMessage: "Dans quels secteurs d'activité intervenez-vous ?" }),
      answer: intl.formatMessage({ id: "faq.answer2", defaultMessage: "Nous intervenons dans divers secteurs tels que la sécurité publique, les télécommunications, les transports, l'énergie, et les services gouvernementaux." })
    },
    {
      id: 3,
      question: intl.formatMessage({ id: "faq.question3", defaultMessage: "Proposez-vous des formations sur vos produits ?" }),
      answer: intl.formatMessage({ id: "faq.answer3", defaultMessage: "Oui, nous proposons des formations complètes sur tous nos produits et services pour garantir une utilisation optimale de nos solutions." })
    },
    {
      id: 4,
      question: intl.formatMessage({ id: "faq.question4", defaultMessage: "Quel est votre délai de livraison moyen ?" }),
      answer: intl.formatMessage({ id: "faq.answer4", defaultMessage: "Nos délais de livraison varient selon la complexité du projet, mais nous nous engageons généralement sur un délai de 30 à 60 jours ouvrables." })
    },
    {
      id: 5,
      question: intl.formatMessage({ id: "faq.question5", defaultMessage: "Offrez-vous un support technique après-vente ?" }),
      answer: intl.formatMessage({ id: "faq.answer5", defaultMessage: "Oui, nous fournissons un support technique complet avec différentes options de maintenance et d'assistance selon vos besoins." })
    }
  ];

  return (
    <Layout data={{ title: intl.formatMessage({ id: "faq.title", defaultMessage: "Foire aux questions" }) }}>
      <div className="min-h-screen bg-white">
        {/* Hero Section */}
        <div className="relative bg-[#0a1628]">
          <div className="relative max-w-[1400px] mx-auto px-5 sm:px-8 lg:px-12 py-16 md:py-24">
            <div className="text-white max-w-3xl">
              <div className="flex items-center gap-3 mb-4">
                <span className="w-8 h-px bg-[#16A34A]"></span>
                <span className="text-[11px] font-semibold tracking-[0.22em] uppercase text-[#16A34A]">Africa Systems</span>
              </div>
              <h1 className="text-4xl md:text-5xl font-bold mb-4">
                {intl.formatMessage({ id: "faq.title", defaultMessage: "Foire aux questions" })}
              </h1>
              <p className="text-xl text-white/75">
                {intl.formatMessage({ id: "faq.subtitle", defaultMessage: "Trouvez les réponses aux questions les plus fréquentes" })}
              </p>
            </div>
          </div>
        </div>

        {/* FAQ Content */}
        <div className="py-16">
          <div className="max-w-4xl mx-auto px-5 sm:px-8 lg:px-12">
            <div className="bg-white rounded-xl border border-slate-200 p-8">
              <div className="space-y-6">
                {faqs.map((faq) => (
                  <div key={faq.id} className="border-b border-slate-200 pb-6 last:border-0 last:pb-0">
                    <h3 className="text-xl font-semibold text-[#0a1628] mb-3">
                      {faq.question}
                    </h3>
                    <p className="text-slate-700 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                ))}
              </div>
              
              {/* Contact CTA */}
              <div className="mt-12 p-6 bg-neutral-50 rounded-lg border border-slate-200">
                <h3 className="text-lg font-semibold text-[#0a1628] mb-2">
                  {intl.formatMessage({ id: "faq.stillHaveQuestions", defaultMessage: "Vous avez encore des questions ?" })}
                </h3>
                <p className="text-slate-700 mb-4">
                  {intl.formatMessage({ id: "faq.contactUs", defaultMessage: "Contactez notre équipe pour obtenir des réponses personnalisées." })}
                </p>
                <a 
                  href={getLocalizedPath("/contact", language)}
                  className="inline-block bg-[#16A34A] hover:bg-[#15803D] text-white px-6 py-3 text-xs font-semibold uppercase tracking-[0.14em] transition-colors duration-300"
                >
                  {intl.formatMessage({ id: "faq.contactButton", defaultMessage: "Nous contacter" })}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Faq;
